import script from "./MaterialLib.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialLib.vue?vue&type=script&setup=true&lang=js"

import "./MaterialLib.vue?vue&type=style&index=0&id=d59ae356&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d59ae356"]])

export default __exports__